<div class="modal-header">
  <h4 style="padding-right: 4px;" class="modal-title">Azure Account</h4>
  <button style="margin-right:4px;" type="button" class="close" aria-label="Close"
    (click)="activeModal.dismiss('Cross click')">
    <i style="font-size:16px;" class="fas fa-times"></i>
  </button>
</div>

<div class="modal-body">
  <div class="modal-body-inner">
    <form (ngSubmit)="createEditAccount()" [formGroup]="accountForm">
      <div class="form-group">
        <label class="d-block">
          <label labelfor="name" class="input-label">* Account Name</label>
          <input type="text" placeholder="Enter your Azure account name" formControlName="Name" />
          <label [ngClass]="isAccountNameEntered ? '' : 'active'" class="error">Azure account name is a required
            field.</label>
        </label>
      </div>
      <div class="form-group">
        <label class="d-block">
          <label labelfor="subscriptionId" class="input-label">* Subscription Id</label>
          <input type="text" placeholder="Enter your Azure account subsription id" formControlName="SubscriptionId" />
          <label [ngClass]="isSubscriptionIdEntered ? '' : 'active'" class="error">Subscription Id is a required
            field.</label>
        </label>
      </div>
      <div *ngIf="this.azureAccountId && this.azureAccountId > 0" class="form-group">
        <label class="d-block">

          <label style="color:#000" class="container-checkbox">
            Active
            <input type="checkbox" formControlName="checkActive" />
            <span class="checkmark"></span>
          </label>
        </label>
      </div>


      <div class="form-group">
        <button type="submit" class="btn btn-success btn-login" type="submit">
          <span [hidden]="isLoading">Save</span>
          <span [hidden]="!isLoading">
            <i class="fas fa-spinner fa-pulse"></i>
          </span>
        </button>
        <div [hidden]="!isErrorVisible" class="alert alert-danger mt-2" role="alert">
          {{error}}
        </div>

      </div>
    </form>
  </div>
</div>
